import React, { useState, useEffect, useCallback } from "react";
import AdminHeader from "../../AdminHeader";
import { APP_API_V1_BASE } from "../../../config/api";
import axios from "axios";
import {
  Box,
  Card,
  Typography,
  TextField,
  MenuItem,
  Button,
  Chip,
  Avatar,
  CircularProgress,
  Drawer,
  Divider,
  Stack,
  IconButton,
  InputAdornment,
  Tabs,
  Tab,
  Tooltip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";

import { DataGrid } from "@mui/x-data-grid";
import {
  Add,
  AddLocation,
  Assessment,
  Assignment,
  Close,
  Delete,
  Edit,
  Search,
} from "@mui/icons-material";
import CreateShiftAttendanceModel from "../models/CreateShiftAttendanceModel";
import AssignShiftModel from "../models/AssignShiftModel";
import CreateLocation from "../models/CreateLocation";

const ATTENDANCE_API = `${APP_API_V1_BASE}/attendance`;

const STATUS_META = {
  present: {
    label: "Present",
    bg: "#EAF3DE",
    color: "#27500A",
  },
  absent: {
    label: "Absent",
    bg: "#FCEBEB",
    color: "#791F1F",
  },
  late: {
    label: "Late",
    bg: "#FAEEDA",
    color: "#633806",
  },
  halfday: {
    label: "Half Day",
    bg: "#E6F1FB",
    color: "#0C447C",
  },
};

function StatCard({ title, value, color }) {
  return (
    <Card
      sx={{
        p: 2,
        height: "100%",
        borderRadius: 3,
      }}
    >
      <Typography variant="h4" fontWeight={700} color={color || "#111"}>
        {value}
      </Typography>

      <Typography variant="body2" color="text.secondary">
        {title}
      </Typography>
    </Card>
  );
}

export default function Attendance() {
  const [allData, setAllData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [filteredAssignShift, setFilteredAssignShift] = useState([]);
  const [filteredLocation, setFilteredLocation] = useState([]);

  const [loading, setLoading] = useState(true);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [selectedAttendance, setSelectedAttendance] = useState(null);
  const [openCreateModal, setOpenCreateModal] = useState(false);
  const [openAssignModal, setOpenAssignModal] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [shiftSearchText, setShiftSearchText] = useState("");
  const [locationSearchText, setLocationSearchText] = useState("");
  const [activeTab, setActiveTab] = useState(0);
  const [assignShift, setAssignShift] = useState([]);
  const [Createlocation, setCreateLocation] = useState([]);
  const [assignPunch, setAssignPunch] = useState([]);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [userFilter, setUserFilter] = useState("all");
  const [openCreateLocation, setOpenCreateLocation] = useState(false);
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [locationToDelete, setLocationToDelete] = useState(null);
  const [assignmentToDelete, setAssignmentToDelete] = useState(null);
  const [deleteDialogType, setDeleteDialogType] = useState("");
  const [editingShiftId, setEditingShiftId] = useState(null);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [punches, setPunches] = useState([]);
  const [punchLoading, setPunchLoading] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [createShift, setCreateShift] = useState({
    ShiftName: "",
    startTime: "",
    endTime: "",
    nightShift: "No",
  });

  const token = localStorage.getItem("authToken");
  const getAssignmentPunchMode = (row) => {
    const punch = assignPunch.find((item) => item.user_id === row.user_id);
    return row.punch_mode || punch?.punch_mode || "";
  };

  const handleOpenAssignModal = () => {
    setSelectedRow(null);
    setIsEdit(false);
    setOpenAssignModal(true);
  };

  const handleEditAssignment = (row) => {
    setSelectedRow({
      ...row,
      punch_mode: getAssignmentPunchMode(row),
    });
    setIsEdit(true);
    setOpenAssignModal(true);
  };
  const handleEdit = (row) => {
    setSelectedLocation(row);
    setOpenCreateLocation(true);
  };
  const handleCreateLocation = () => {
    setSelectedLocation(null);
    setOpenCreateLocation(true);
  };
  const handleDeleteLocation = (row) => {
    setLocationToDelete(row);
    setAssignmentToDelete(null);
    setDeleteDialogType("location");
    setDeleteDialogOpen(true);
  };
  const handleDeleteAssignment = (row) => {
    setAssignmentToDelete(row);
    setLocationToDelete(null);
    setDeleteDialogType("assignment");
    setDeleteDialogOpen(true);
  };
  const confirmDelete = async () => {
    if (deleteDialogType === "location" && !locationToDelete) return;
    if (deleteDialogType === "assignment" && !assignmentToDelete) return;

    try {
      setDeleteLoading(true);

      if (deleteDialogType === "assignment") {
        await axios.delete(`${ATTENDANCE_API}/delete/assignment`, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          data: {
            user_ids: [assignmentToDelete.user_id],
            remove_shift: true,
            remove_location: true,
            remove_punch_mode: true,
          },
        });
      } else {
        await axios.delete(
          `${APP_API_V1_BASE}/attendance/location/${locationToDelete.id}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );
      }

      setDeleteDialogOpen(false);
      setLocationToDelete(null);
      setAssignmentToDelete(null);
      setDeleteDialogType("");

      fetchAttendance();
    } catch (error) {
      console.error(error);
    } finally {
      setDeleteLoading(false);
    }
  };
  const cancelDelete = () => {
    setDeleteDialogOpen(false);
    setLocationToDelete(null);
    setAssignmentToDelete(null);
    setDeleteDialogType("");
  };
  const handleAttendanceSubmit = async () => {
    try {
      const payload = {
        name: createShift.ShiftName,
        start_time: createShift.startTime,
        end_time: createShift.endTime,
        is_night_shift: createShift.nightShift === "Yes",
      };

      const response = await axios.post(`${ATTENDANCE_API}/shift`, payload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      setCreateShift({
        ShiftName: "",
        startTime: "",
        endTime: "",
        nightShift: "No",
      });

      setOpenCreateModal(false);

      fetchAttendance();
    } catch (error) {
      console.error(
        "Create Shift Error:",
        error.response?.data || error.message,
      );
    }
  };

  const fetchAttendance = useCallback(async () => {
    try {
      setLoading(true);

      const res = await fetch(ATTENDANCE_API, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      const resshift = await fetch(`${ATTENDANCE_API}/shift/assignments`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      const reslocation = await fetch(`${ATTENDANCE_API}/location`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      const assignpunch = await fetch(`${ATTENDANCE_API}/punch/assigns`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      if (!res.ok) {
        throw new Error("Failed to fetch attendance");
      }

      const data = await res.json();
      const shiftdata = await resshift.json();
      const locationdata = await reslocation.json();
      const punch = await assignpunch.json();

      console.log(punch, 670);
      setAllData(data);
      setAssignShift(shiftdata);
      setCreateLocation(locationdata);
      setAssignPunch(punch);
      setFilteredData(data);
      setFilteredLocation(locationdata);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  }, [token]);
  const fetchPunches = async (attendanceId) => {
    try {
      setPunchLoading(true);

      const res = await axios.get(`${ATTENDANCE_API}/${attendanceId}/punches`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setPunches(res.data.punches || []);
    } catch (error) {
      console.error("Failed to fetch punches:", error);
      setPunches([]);
    } finally {
      setPunchLoading(false);
    }
  };

  useEffect(() => {
    fetchAttendance();
  }, [fetchAttendance]);

  useEffect(() => {
    const normalize = (value) =>
      String(value || "")
        .toLowerCase()
        .trim();
    const isInDateRange = (dateValue, requireDate = true) => {
      if (!fromDate && !toDate) {
        return true;
      }

      if (!dateValue) {
        return !requireDate;
      }

      const dateOnly = String(dateValue).slice(0, 10);

      if (fromDate && dateOnly < fromDate) {
        return false;
      }

      if (toDate && dateOnly > toDate) {
        return false;
      }

      return true;
    };
    // Location Search
    let locationResult = [...Createlocation];

    if (locationSearchText.trim()) {
      const searchValue = normalize(locationSearchText);

      locationResult = locationResult.filter(
        (item) =>
          normalize(item.name).includes(searchValue) ||
          normalize(item.latitude).includes(searchValue) ||
          normalize(item.longitude).includes(searchValue) ||
          normalize(item.address).includes(searchValue) ||
          normalize(item.radius).includes(searchValue),
      );
    }

    setFilteredLocation(locationResult);

    // Attendance Search
    let attendanceResult = [...allData];
    const selectedUser = normalize(userFilter);

    if (searchText.trim()) {
      const searchValue = normalize(searchText);

      attendanceResult = attendanceResult.filter(
        (item) =>
          normalize(item.user_name).includes(searchValue) ||
          normalize(item.email).includes(searchValue) ||
          normalize(item.attendance_date).includes(searchValue) ||
          normalize(item.status).includes(searchValue) ||
          normalize(item.shift?.name).includes(searchValue),
      );
    }

    if (userFilter !== "all") {
      attendanceResult = attendanceResult.filter(
        (item) => normalize(item.user_name) === selectedUser,
      );
    }

    attendanceResult = attendanceResult.filter((item) =>
      isInDateRange(item.attendance_date),
    );

    setFilteredData(attendanceResult);

    // Assigned Shift Search
    let shiftResult = [...assignShift];

    if (shiftSearchText.trim()) {
      const searchValue = normalize(shiftSearchText);

      shiftResult = shiftResult.filter(
        (item) =>
          normalize(item.user_name).includes(searchValue) ||
          normalize(item.email).includes(searchValue) ||
          normalize(item.shift?.name).includes(searchValue) ||
          normalize(item.shift?.start_time).includes(searchValue) ||
          normalize(item.shift?.end_time).includes(searchValue),
      );
    }

    if (userFilter !== "all") {
      shiftResult = shiftResult.filter(
        (item) => normalize(item.user_name) === selectedUser,
      );
    }

    shiftResult = shiftResult.filter((item) =>
      isInDateRange(
        item.attendance_date ||
        item.assigned_date ||
        item.effective_date ||
        item.date ||
        item.created_at,
        false,
      ),
    );

    setFilteredAssignShift(shiftResult);
  }, [
    searchText,
    shiftSearchText,
    locationSearchText,
    userFilter,
    fromDate,
    toDate,
    allData,
    assignShift,
    Createlocation,
  ]);

  const userOptions = Array.from(
    new Set(
      [...allData, ...assignShift]
        .map((item) => item.user_name)
        .filter(Boolean),
    ),
  ).sort((a, b) => a.localeCompare(b));

  const currentSearchText =
    activeTab === 0
      ? searchText
      : activeTab === 1
        ? shiftSearchText
        : locationSearchText;
  const handleSearchChange = (value) => {
    if (activeTab === 0) {
      setSearchText(value);
    } else if (activeTab === 1) {
      setShiftSearchText(value);
    } else {
      setLocationSearchText(value);
    }
  };

  const handleClearSearch = () => {
    handleSearchChange("");
  };

  const attendance = [
    {
      field: "srNo",
      headerName: "S.No",
      width: 80,
      sortable: false,
      renderCell: (params) => params.api.getAllRowIds().indexOf(params.id) + 1,
    },

    {
      field: "user_name",
      headerName: "Employee",
      flex: 1.5,
      minWidth: 130,

      renderCell: (params) => (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
          }}
        >
          {params.value}
        </Box>
      ),
    },

    {
      field: "attendance_date",
      headerName: "Date",
      flex: 1,
      minWidth: 120,
    },

    {
      field: "clock_in_time",
      headerName: "Clock In",
      flex: 1,
      minWidth: 180,
    },

    {
      field: "clock_out_time",
      headerName: "Clock Out",
      flex: 1,
      minWidth: 180,
    },

    {
      field: "working_time",
      headerName: "Working Hours",
      flex: 1,
      minWidth: 140,
    },
    {
      field: "shift",
      headerName: "Shift",
      flex: 1,
      minWidth: 250,
      renderCell: (params) => {
        const shift = params.row.shift;

        return (
          <Typography
            variant="body2"
            sx={{
              py: 1,
              color: "#333",
            }}
          >
            {shift
              ? `${shift.name || "N/A"} (${shift.start_time || "N/A"} - ${shift.end_time || "N/A"
              })`
              : "N/A"}
          </Typography>
        );
      },
    },

    {
      field: "status",
      headerName: "Status",
      flex: 1,
      minWidth: 140,

      renderCell: (params) => {
        const meta = STATUS_META[params.value] || STATUS_META.present;

        return (
          <Chip
            label={meta.label}
            size="small"
            sx={{
              backgroundColor: meta.bg,
              color: meta.color,
              fontWeight: 600,
            }}
          />
        );
      },
    },

    {
      field: "is_auto_clock_out",
      headerName: "Auto Clock Out",
      flex: 1,
      minWidth: 160,

      renderCell: (params) =>
        params.value ? (
          <Box
            sx={{
              color: "warning.main",
              fontWeight: 600,
            }}
          >
            Missing
          </Box>
        ) : (
          ""
        ),
    },
  ];
  const assignedShift = [
    {
      field: "srNo",
      headerName: "S.No",
      width: 80,
      sortable: false,
      renderCell: (params) => params.api.getAllRowIds().indexOf(params.id) + 1,
    },
    {
      field: "user_name",
      headerName: "Employee",
      flex: 1.5,
      minWidth: 130,

      renderCell: (params) => (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
          }}
        >
          {params.value}
        </Box>
      ),
    },
    {
      field: "email",
      headerName: "Email",
      flex: 1.5,
      minWidth: 150,
    },
    {
      field: "shiftname",
      headerName: "Shift",
      flex: 1.5,
      minWidth: 120,
      renderCell: (params) => params.row.shift?.name,
    },
    {
      field: "attendance_location",
      headerName: "Location Name",
      flex: 1.5,
      minWidth: 150,
      renderCell: (params) => params.row.attendance_location?.name || "N/A",
    },
    {
      field: "punch_mode",
      headerName: "Punch Mode",
      flex: 1.5,
      minWidth: 150,
      renderCell: (params) => {
        const punch = assignPunch.find(
          (item) => item.user_id === params.row.user_id,
        );

        return punch?.punch_mode || "N/A";
      },
    },
    {
      field: "shiftstart",
      headerName: "Start Time",
      flex: 1.5,
      minWidth: 130,
      renderCell: (params) => params.row.shift?.start_time || "N/A",
    },
    {
      field: "shiftend",
      headerName: "End Time",
      flex: 1.5,
      minWidth: 130,
      renderCell: (params) => params.row.shift?.end_time || "N/A",
    },
    {
      field: "actions",
      headerName: "Actions",
      minWidth: 120,
      sortable: false,
      filterable: false,
      renderCell: (params) => (
        <>
          <Tooltip title="Edit">
            <IconButton
              color="primary"
              onClick={() => handleEditAssignment(params.row)}
            >
              <Edit fontSize="small" />
            </IconButton>
          </Tooltip>

          <Tooltip title="Delete">
            <IconButton
              color="error"
              onClick={() => handleDeleteAssignment(params.row)}
            >
              <Delete fontSize="small" />
            </IconButton>
          </Tooltip>
        </>
      ),
    },
  ];
  const locations = [
    {
      field: "srNo",
      headerName: "S.No",
      width: 80,
      sortable: false,
      renderCell: (params) => params.api.getAllRowIds().indexOf(params.id) + 1,
    },
    {
      field: "name",
      headerName: "Name",
      flex: 1.5,
      minWidth: 150,
    },
    {
      field: "latitude",
      headerName: "Latitude",
      flex: 1.5,
      minWidth: 130,
    },
    {
      field: "longitude",
      headerName: "Longitude",
      flex: 1.5,
      minWidth: 130,
    },
    {
      field: "address",
      headerName: "Address",
      flex: 1.5,
      minWidth: 150,
    },
    {
      field: "radius",
      headerName: "Radius(Meter)",
      flex: 1.5,
      minWidth: 100,
      // renderCell: (params) => params.row.shift?.end_time,
    },
    {
      field: "actions",
      headerName: "Actions",
      minWidth: 120,
      sortable: false,
      filterable: false,
      renderCell: (params) => (
        <>
          <Tooltip title="Edit">
            <IconButton color="primary" onClick={() => handleEdit(params.row)}>
              <Edit fontSize="small" />
            </IconButton>
          </Tooltip>

          <Tooltip title="Delete">
            <IconButton
              color="error"
              onClick={() => handleDeleteLocation(params.row)}
            >
              <Delete fontSize="small" />
            </IconButton>
          </Tooltip>
        </>
      ),
    },
  ];

  const StatCard = ({ title, value }) => (
    <Box
      sx={{
        p: 2.5,
        borderRadius: 3,
        bgcolor: "rgba(255,255,255,0.08)",
        backdropFilter: "blur(6px)",
        border: "1px solid rgba(255,255,255,0.12)",
        color: "#fff",
      }}
    >
      <Typography
        variant="body2"
        sx={{
          opacity: 0.8,
          mb: 1,
        }}
      >
        {title}
      </Typography>

      <Typography variant="h4" fontWeight={700}>
        {value}
      </Typography>
    </Box>
  );

  return (
    <>
      <Box
        sx={{
          p: 2,
          background:
            "radial-gradient(circle at top left, rgba(14, 165, 233, 0.14), transparent 30%), radial-gradient(circle at top right, rgba(16, 185, 129, 0.12), transparent 28%), linear-gradient(180deg, #f8fbff 0%, #eef4f8 100%)",
        }}
      >
        <AdminHeader title="Attendance" />
        {/* Top Banner */}

        <Box
          sx={{
            background:
              "linear-gradient(135deg, rgba(15, 23, 42, 0.96), rgba(15, 118, 110, 0.88) 55%, rgba(8, 47, 73, 0.92))",
            borderRadius: 4,
            p: { xs: 2, sm: 3 },
            color: "#fff",
            mb: 3,
          }}
        >
          {/* Header */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: {
                xs: "flex-start",
                md: "center",
              },
              flexDirection: {
                xs: "column",
                md: "row",
              },
              gap: 2,
              mb: 4,
            }}
          >
            <Box>
              <Typography
                variant="h4"
                fontWeight={700}
                sx={{
                  fontSize: {
                    xs: 28,
                    md: 40,
                  },
                }}
              >
                Attendance Log
              </Typography>

              <Typography
                variant="body1"
                sx={{
                  opacity: 0.9,
                }}
              >
                Monitor employee attendance, clock-in / clock-out activities and
                working hours.
              </Typography>
            </Box>

            <Box
              sx={{
                display: "flex",
                flexDirection: { xs: "column", md: "row" },
                gap: 2,
                width: {
                  xs: "100%",
                  md: "auto",
                },
                alignItems: {
                  xs: "stretch",
                  md: "flex-end",
                },
              }}
            >
              <Button
                variant="contained"
                onClick={handleCreateLocation}
                sx={{
                  px: 2.2,
                  py: 1.1,
                  borderRadius: 999,
                  textTransform: "none",
                  fontWeight: 700,
                  whiteSpace: "nowrap",
                  color: "#082F49",
                  background: "linear-gradient(135deg, #FDE68A, #F59E0B)",
                  boxShadow: "0 16px 30px rgba(245, 158, 11, 0.28)",
                }}
              >
                <IconButton>
                  <AddLocation
                    sx={{
                      color: "#0e0e0e",
                    }}
                  />
                </IconButton>
                Create Location
              </Button>
              <Button
                variant="contained"
                onClick={() => setOpenCreateModal(true)}
                sx={{
                  px: 2.2,
                  py: 1.1,
                  borderRadius: 999,
                  textTransform: "none",
                  fontWeight: 700,
                  whiteSpace: "nowrap",
                  color: "#082F49",
                  background: "linear-gradient(135deg, #FDE68A, #F59E0B)",
                  boxShadow: "0 16px 30px rgba(245, 158, 11, 0.28)",
                }}
              >
                <IconButton>
                  <Add
                    sx={{
                      color: "#0e0e0e",
                    }}
                  />
                </IconButton>
                Create Shift
              </Button>

              <Button
                variant="contained"
                onClick={handleOpenAssignModal}
                sx={{
                  px: 2.2,
                  py: 1.1,
                  borderRadius: 999,
                  textTransform: "none",
                  fontWeight: 700,
                  whiteSpace: "nowrap",
                  color: "#082F49",
                  background: "linear-gradient(135deg, #FDE68A, #F59E0B)",
                  boxShadow: "0 16px 30px rgba(245, 158, 11, 0.28)",
                }}
              >
                <IconButton>
                  <Assignment sx={{ color: "#141313" }} />
                </IconButton>
                Assign Shift
              </Button>
            </Box>
          </Box>

          {/* Stats Cards */}
        </Box>

        {/* DataGrid */}

        <Card
          sx={{
            borderRadius: 4,
            overflow: "hidden",
            border: "1px solid #e5e7eb",
            boxShadow: "0 8px 24px rgba(0,0,0,0.08)",
          }}
        >
          <Box
            sx={{
              background:
                "linear-gradient(135deg, rgba(15, 23, 42, 0.96), rgba(15, 118, 110, 0.88) 55%, rgba(8, 47, 73, 0.92))",
              color: "#fff",
              p: 2.5,
              display: "flex",
              justifyContent: "space-between",
              alignItems: {
                xs: "flex-start",
                lg: "center",
              },
              flexDirection: {
                xs: "column",
                lg: "row",
              },
              gap: 2,
            }}
          >
            <Box>
              <Typography
                variant="h6"
                fontWeight={600}
                sx={{
                  fontSize: {
                    xs: 15,
                    md: 20,
                  },
                }}
              >
                Details
              </Typography>

              <Typography
                variant="body2"
                sx={{
                  opacity: 0.85,
                }}
              >
                Search and filter attendance records.
              </Typography>
            </Box>

            <Box
              sx={{
                display: "flex",
                gap: 1.5,
                flexWrap: "wrap",
                width: {
                  xs: "100%",
                  lg: "auto",
                },
              }}
            >
              <Box
                sx={{
                  width: "100%",
                  borderBottom: 1,
                  borderColor: "rgba(255,255,255,0.2)",
                  overflowX: "auto",
                }}
              >
                <Tabs
                  value={activeTab}
                  onChange={(e, newValue) => {
                    setActiveTab(newValue);
                    fetchAttendance();
                  }}
                  variant="scrollable"
                  scrollButtons={false}
                  allowScrollButtonsMobile={false}
                  textColor="inherit"
                  indicatorColor="secondary"
                  sx={{
                    "& .MuiTabs-scroller": {
                      overflowX: "auto !important",
                    },

                    "& .MuiTabs-flexContainer": {
                      width: {
                        xs: "max-content",
                        sm: "100%",
                      },
                    },

                    "& .MuiTab-root": {
                      flex: {
                        xs: "0 0 auto",
                        sm: 1,
                      },
                      minWidth: {
                        xs: 120,
                        sm: 0,
                      },
                      color: "rgba(255,255,255,0.7)",
                      textTransform: "none",
                      fontWeight: 600,
                      fontSize: {
                        xs: "0.8rem",
                        sm: "0.9rem",
                        md: "1rem",
                      },
                      px: {
                        xs: 2,
                        sm: 3,
                      },
                    },

                    "& .Mui-selected": {
                      color: "#fff !important",
                    },

                    "& .MuiTabs-indicator": {
                      backgroundColor: "#fff",
                    },
                  }}
                >
                  <Tab label="Attendance" />
                  <Tab label="Assigned Shifts" />
                  <Tab label="Locations" />
                </Tabs>
              </Box>
              <TextField
                select
                label="User Name"
                size="small"
                value={userFilter}
                onChange={(e) => setUserFilter(e.target.value)}
                sx={{
                  // minWidth: 150,
                  width: { xs: "100%", md: 150 },

                  "& .MuiOutlinedInput-root": {
                    color: "#fff",

                    "& fieldset": {
                      borderColor: "rgba(255,255,255,0.25)",
                    },

                    "&:hover fieldset": {
                      borderColor: "rgba(255,255,255,0.5)",
                    },

                    "&.Mui-focused fieldset": {
                      borderColor: "#fff",
                    },
                  },
                  "& .MuiInputBase-input::placeholder": {
                    color: "#cbd5e1",
                    opacity: 1,
                  },
                  "& .MuiInputLabel-root": {
                    color: "#cbd5e1",
                  },
                  "& .MuiInputLabel-root.Mui-focused": {
                    color: "#fff",
                  },

                  "& .MuiSelect-icon": {
                    color: "#fff",
                  },
                }}
              >
                <MenuItem value="all">All Users</MenuItem>
                {userOptions.map((name) => (
                  <MenuItem key={name} value={name}>
                    {name}
                  </MenuItem>
                ))}
              </TextField>
              {/* From Date */}
              <TextField
                size="small"
                type="date"
                label="From Date"
                value={fromDate}
                onChange={(e) => setFromDate(e.target.value)}
                InputLabelProps={{ shrink: true }}
                sx={{
                  // minWidth: 180,

                  width: { xs: "100%", md: 180 },
                  "& .MuiOutlinedInput-root": {
                    color: "#fff",

                    "& fieldset": {
                      borderColor: "rgba(255,255,255,0.25)",
                    },

                    "&:hover fieldset": {
                      borderColor: "rgba(255,255,255,0.5)",
                    },

                    "&.Mui-focused fieldset": {
                      borderColor: "#fff",
                    },
                  },

                  "& .MuiInputLabel-root": {
                    color: "rgba(255,255,255,0.7)",
                  },

                  "& .MuiInputLabel-root.Mui-focused": {
                    color: "#fff",
                  },

                  "& input::-webkit-calendar-picker-indicator": {
                    filter: "invert(1)",
                    cursor: "pointer",
                  },
                }}
              />

              {/* To Date */}
              <TextField
                size="small"
                type="date"
                label="To Date"
                value={toDate}
                onChange={(e) => setToDate(e.target.value)}
                InputLabelProps={{ shrink: true }}
                sx={{
                  // minWidth: 180,
                  width: { xs: "100%", md: 180 },

                  "& .MuiOutlinedInput-root": {
                    color: "#fff",

                    "& fieldset": {
                      borderColor: "rgba(255,255,255,0.25)",
                    },

                    "&:hover fieldset": {
                      borderColor: "rgba(255,255,255,0.5)",
                    },

                    "&.Mui-focused fieldset": {
                      borderColor: "#fff",
                    },
                  },

                  "& .MuiInputLabel-root": {
                    color: "rgba(255,255,255,0.7)",
                  },

                  "& .MuiInputLabel-root.Mui-focused": {
                    color: "#fff",
                  },

                  "& input::-webkit-calendar-picker-indicator": {
                    filter: "invert(1)",
                    cursor: "pointer",
                  },
                }}
              />
              <TextField
                size="small"
                placeholder="Search employee..."
                value={currentSearchText}
                onChange={(e) => handleSearchChange(e.target.value)}
                sx={{
                  // minWidth: 250,
                  width: { xs: "100%", md: 250 },

                  "& .MuiOutlinedInput-root": {
                    color: "#fff",

                    "& fieldset": {
                      borderColor: "rgba(255,255,255,0.25)",
                    },

                    "&:hover fieldset": {
                      borderColor: "rgba(255,255,255,0.5)",
                    },

                    "&.Mui-focused fieldset": {
                      borderColor: "#fff",
                    },
                  },

                  "& input::placeholder": {
                    color: "#cbd5e1",
                    opacity: 1, // important
                  },
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Search
                        sx={{
                          color: "rgba(255,255,255,0.7)",
                        }}
                      />
                    </InputAdornment>
                  ),

                  endAdornment: currentSearchText ? (
                    <InputAdornment position="end">
                      <IconButton
                        size="small"
                        onClick={handleClearSearch}
                        sx={{
                          color: "rgba(255,255,255,0.7)",
                        }}
                      >
                        <Close fontSize="small" />
                      </IconButton>
                    </InputAdornment>
                  ) : null,
                }}
              />
            </Box>
          </Box>
          {activeTab === 0 && (
            <Box
              sx={{
                width: "100%",
                height: {
                  xs: 500,
                  md: 650,
                  lg: 700,
                },
              }}
            >
              <DataGrid
                rows={filteredData.map((row, index) => ({
                  ...row,
                  id: row.id || index,
                }))}
                columns={attendance}
                loading={loading}
                disableRowSelectionOnClick
                disableColumnMenu
                disableColumnSorting
                pageSizeOptions={[10, 25, 50, 100]}
                onRowClick={(params) => {
                  setSelectedAttendance(params.row);
                  fetchPunches(params.row.id);
                  setDrawerOpen(true);
                }}
                initialState={{
                  pagination: {
                    paginationModel: {
                      pageSize: 10,
                    },
                  },
                }}
                sx={{
                  border: 0,

                  "& .MuiDataGrid-columnHeaders": {
                    backgroundColor: "#f8fafc",
                    borderBottom: "1px solid #e5e7eb",
                  },

                  "& .MuiDataGrid-columnHeaderTitle": {
                    fontWeight: 700,
                    color: "#334155",
                    fontSize: "14px",
                  },

                  "& .MuiDataGrid-cell": {
                    borderBottom: "1px solid #f1f5f9",
                  },

                  "& .MuiDataGrid-row": {
                    cursor: "pointer",
                  },

                  "& .MuiDataGrid-row:hover": {
                    backgroundColor: "#f8fafc",
                  },

                  "& .MuiDataGrid-footerContainer": {
                    borderTop: "1px solid #e5e7eb",
                  },
                }}
              />
            </Box>
          )}
          {activeTab === 1 && (
            <Box
              sx={{
                width: "100%",
                height: {
                  xs: 500,
                  md: 650,
                  lg: 700,
                },
              }}
            >
              <DataGrid
                rows={filteredAssignShift.map((row, index) => ({
                  ...row,
                  id: row.id || index,
                }))}
                columns={assignedShift}
                loading={loading}
                disableRowSelectionOnClick
                disableColumnMenu
                disableColumnSorting
                pageSizeOptions={[10, 25, 50, 100]}
                // onRowClick={(params) => {
                //   setSelectedAttendance(params.row);
                //   setDrawerOpen(true);
                // }}
                initialState={{
                  pagination: {
                    paginationModel: {
                      pageSize: 10,
                    },
                  },
                }}
                sx={{
                  border: 0,

                  "& .MuiDataGrid-columnHeaders": {
                    backgroundColor: "#f8fafc",
                    borderBottom: "1px solid #e5e7eb",
                  },

                  "& .MuiDataGrid-columnHeaderTitle": {
                    fontWeight: 700,
                    color: "#334155",
                    fontSize: "14px",
                  },

                  "& .MuiDataGrid-cell": {
                    borderBottom: "1px solid #f1f5f9",
                  },

                  "& .MuiDataGrid-row": {
                    cursor: "pointer",
                  },

                  "& .MuiDataGrid-row:hover": {
                    backgroundColor: "#f8fafc",
                  },

                  "& .MuiDataGrid-footerContainer": {
                    borderTop: "1px solid #e5e7eb",
                  },
                }}
              />
            </Box>
          )}
          {activeTab === 2 && (
            <Box
              sx={{
                width: "100%",
                height: {
                  xs: 500,
                  md: 650,
                  lg: 700,
                },
              }}
            >
              <DataGrid
                rows={filteredLocation.map((row, index) => ({
                  ...row,
                  id: row.id || index,
                }))}
                columns={locations}
                loading={loading}
                disableRowSelectionOnClick
                disableColumnMenu
                disableColumnSorting
                pageSizeOptions={[10, 25, 50, 100]}
                // onRowClick={(params) => {
                //   setSelectedAttendance(params.row);
                //   setDrawerOpen(true);
                // }}
                initialState={{
                  pagination: {
                    paginationModel: {
                      pageSize: 10,
                    },
                  },
                }}
                sx={{
                  border: 0,

                  "& .MuiDataGrid-columnHeaders": {
                    backgroundColor: "#f8fafc",
                    borderBottom: "1px solid #e5e7eb",
                  },

                  "& .MuiDataGrid-columnHeaderTitle": {
                    fontWeight: 700,
                    color: "#334155",
                    fontSize: "14px",
                  },

                  "& .MuiDataGrid-cell": {
                    borderBottom: "1px solid #f1f5f9",
                  },

                  "& .MuiDataGrid-row": {
                    cursor: "pointer",
                  },

                  "& .MuiDataGrid-row:hover": {
                    backgroundColor: "#f8fafc",
                  },

                  "& .MuiDataGrid-footerContainer": {
                    borderTop: "1px solid #e5e7eb",
                  },
                }}
              />
            </Box>
          )}
        </Card>
      </Box>
      <Drawer
        anchor="right"
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
        PaperProps={{
          sx: {
            width: { xs: "100%", sm: 420, },
          },
        }}
      >
        {/* Header */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            px: 3,
            py: 2,
            background:
              "linear-gradient(135deg, rgba(15, 23, 42, 0.96), rgba(15, 118, 110, 0.88) 55%, rgba(8, 47, 73, 0.92))",
            color: "#fff",
          }}
        >
          <Typography variant="h6" fontWeight={700}>
            Attendance Details
          </Typography>

          <IconButton
            onClick={() => setDrawerOpen(false)}
            sx={{ color: "#fff" }}
          >
            <Close />
          </IconButton>
        </Box>

        <Divider />

        {/* Content */}
        <Box sx={{ p: 3 }}>
          <Stack spacing={2.5}>
            <Box>
              <Typography variant="caption" color="text.secondary">
                Employee
              </Typography>
              <Typography fontWeight={600}>
                {selectedAttendance?.user_name || "-"}
              </Typography>
            </Box>

            <Box>
              <Typography variant="caption" color="text.secondary">
                Date
              </Typography>
              <Typography>
                {selectedAttendance?.attendance_date || "-"}
              </Typography>
            </Box>

            <Box>
              <Typography variant="caption" color="text.secondary">
                Clock In Time
              </Typography>
              <Typography>
                {selectedAttendance?.clock_in_time || "-"}
              </Typography>
            </Box>

            <Box>
              <Typography variant="caption" color="text.secondary">
                Clock In Address
              </Typography>
              <Typography>
                {selectedAttendance?.clock_in_location?.address || "N/A"}
              </Typography>
            </Box>

            <Box>
              <Typography variant="caption" color="text.secondary">
                Clock Out Time
              </Typography>
              <Typography>
                {selectedAttendance?.clock_out_time || "-"}
              </Typography>
            </Box>

            <Box>
              <Typography variant="caption" color="text.secondary">
                Clock Out Address
              </Typography>
              <Typography>
                {selectedAttendance?.clock_out_location?.address || "N/A"}
              </Typography>
            </Box>

            <Box>
              <Typography variant="caption" color="text.secondary">
                Working Hours
              </Typography>
              <Typography>{selectedAttendance?.working_time || "-"}</Typography>
            </Box>

            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
              }}
            >
              <Typography variant="caption" color="text.secondary">
                Status
              </Typography>

              <Chip
                label={selectedAttendance?.status || "-"}
                size="small"
                color={
                  selectedAttendance?.status === "completed"
                    ? "success"
                    : "warning"
                }
                sx={{ textTransform: "capitalize" }}
              />
            </Box>

            <Box>
              <Typography variant="caption" color="text.secondary">
                Auto Clock Out
              </Typography>
              <Typography>
                {selectedAttendance?.is_auto_clock_out ? "Yes" : "No"}
              </Typography>
            </Box>

            {/* <Divider sx={{ my: 2 }} /> */}
            <Typography variant="h8" fontWeight={500}>
              Punch History
            </Typography>
            <Box

              sx={{
                height: "550px",
                overflowY: "auto"
              }}
            >


              {punchLoading ? (
                <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
                  <CircularProgress size={24} />
                </Box>
              ) : punches.length === 0 ? (
                <Typography variant="caption" color="text.secondary" align="center" sx={{
                  display: "block",
                  width: "100%",
                  mt: 1,
                }}>
                  No Punches Found
                </Typography>
              ) : (
                <Stack spacing={2}>
                  {punches.map((punch) => (
                    <Box
                      key={punch.id}
                      // variant="outlined"
                      sx={{

                        borderRadius: 2,
                        fontSize: 14,
                        lineHeight: 1.4,
                        py: 0.1,
                      }}
                    >
                      <Typography fontWeight={600}>
                        Punch #{punch.punch_number}
                      </Typography>

                      <Typography variant="body2">
                        Time : {punch.punch_time}
                      </Typography>

                      <Typography variant="body2">
                        Address : {punch.address}
                      </Typography>
                    </Box>
                  ))}
                </Stack>
              )}
            </Box>
          </Stack>
        </Box>
      </Drawer>
      <Dialog
        open={deleteDialogOpen}
        onClose={cancelDelete}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle
          sx={{
            p: 0,
            background:
              "linear-gradient(135deg, rgba(15,23,42,.96), rgba(15,118,110,.88) 55%, rgba(8,47,73,.92))",
          }}
        >
          <Box
            sx={{
              px: 3,
              py: 2,
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Typography variant="h6" fontWeight={600} color="#fff">
              {deleteDialogType === "assignment"
                ? "Delete Assignment"
                : "Delete Location"}
            </Typography>

            <IconButton
              onClick={cancelDelete} // or handleClose
              sx={{ color: "#fff" }}
            >
              <Close />
            </IconButton>
          </Box>
        </DialogTitle>

        <DialogContent sx={{ pt: 3 }}>
          <Typography>
            Are you sure you want to delete
            <strong>
              {" "}
              {deleteDialogType === "assignment"
                ? assignmentToDelete?.user_name
                : locationToDelete?.name}
            </strong>
            ?
          </Typography>

          <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
            This action cannot be undone.
          </Typography>
        </DialogContent>

        <DialogActions sx={{ p: 2 }}>
          <Button onClick={cancelDelete} disabled={deleteLoading}>
            Cancel
          </Button>

          <Button
            variant="contained"
            color="error"
            onClick={confirmDelete}
            disabled={deleteLoading}
          >
            {deleteLoading ? (
              <CircularProgress size={18} color="inherit" />
            ) : (
              "Delete"
            )}
          </Button>
        </DialogActions>
      </Dialog>
      <CreateShiftAttendanceModel
        open={openCreateModal}
        onClose={() => setOpenCreateModal(false)}
        form={createShift}
        setForm={setCreateShift}
        onSubmit={handleAttendanceSubmit}
        isEdit={false}
      />

      <AssignShiftModel
        open={openAssignModal}
        onClose={() => {
          setOpenAssignModal(false);
          setSelectedRow(null);
          setIsEdit(false);
        }}
        onSuccess={() => {
          fetchAttendance();
          setOpenAssignModal(false);
          setSelectedRow(null);
          setIsEdit(false);
        }}
        editData={selectedRow}
        isEdit={isEdit}
      />
      <CreateLocation
        open={openCreateLocation}
        locationData={selectedLocation}
        onClose={() => {
          setOpenCreateLocation(false);
          setSelectedLocation(null);
        }}
        onSuccess={() => {
          fetchAttendance();
          setOpenCreateLocation(false);
          setSelectedLocation(null);
        }}
      />
    </>
  );
}
